import { getIn } from 'formik';
import { HTTP_STATUSES } from 'libs/constants';
import { formatWaitTime } from 'libs/dateTimeHelpers';

export const getTooManyRequestsMessage = (error: unknown): string | undefined => {
  if (getIn(error, 'response.status') !== HTTP_STATUSES.tooManyRequests) return undefined;

  const seconds = Number(getIn(error, 'response.headers.retry-after'));
  return seconds > 0
    ? `Too many attempts. Please try again in ${formatWaitTime(seconds)}.`
    : 'Too many attempts. Please try again later.';
};
